import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


const mapStateToPropsForHideInWebview = (state) => {
  let isEmbbedInBuyerApp = false;
  if (state && state.md) {
    // eslint-disable-next-line prefer-destructuring
    isEmbbedInBuyerApp = state.md.isEmbbedInBuyerApp;
  }
  return { isEmbbedInBuyerApp };
};

export const HideInWebviewHoc = (WrappedComponent) => {
  const HideInWebview = (props) => {
    // in SSR html we want the html rendert but in the client we want to stop the rendering if we don'tt need it
    const [canRenderInClient, setCanRenderInClient] = useState(true);
    const { isEmbbedInBuyerApp } = props;
    useEffect(() => {
      if (isEmbbedInBuyerApp) {
        setCanRenderInClient(false);
      }
    }, [isEmbbedInBuyerApp]);
    if (canRenderInClient) {
      return (
        // the helper_hide-in-webview will be hidden when we add the class 'is-in-webview' give we are in a webview
        // this is set by inline JS on top of the HTML
        <div className="helper_hide-in-webview">
          <WrappedComponent {...props} />
        </div>
      );
    }
    return null;
  };
  HideInWebview.propTypes = {
    isEmbbedInBuyerApp: PropTypes.bool.isRequired,
  };

  return connect(mapStateToPropsForHideInWebview)(HideInWebview);
};
